import React from 'react';
import { Input, Button, PaperClip, TitleModalRight, Textarea, Select } from 'components';
import { ComboService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { CloseWhiteIcon, CloseIcon } from 'assets/icons';
import ModalSelectProducts from './modal-select-products';

interface Props {
	onClose?: any;
	item?: any;
	title?: string;
}

class ModalCreateCombo extends React.Component<Props> {

	state = {
		form: {
			name: '',
			price: '',
			description: ''
		},
		photos: [],
		photos_deleted: [],
		visible: false,
		products: []
	}

	componentDidMount() {
		if (this.props.item) {
			this.load();
		}
	}

	load = async () => {
		const res: any = await ComboService.admin.view({
			product_id: this.props.item?.id
		});
		this.setState({
			form: {
				...this.state.form,
				name: this.props.item?.name || '',
				price: this.props.item?.price || '',
				description: this.props.item?.description || ''
			},
			photos: this.props.item?.photos || [],
			products: res.products || []
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (this.state.products.length == 0) {
			Globals.showError("Debe agregar por lo menos un producto al combo");
			return;
		}

		if (this.state.photos.length == 0) {
			Globals.showError("Debe ingresar al menos una foto del producto");
			return;
		}

		if (this.props.item != null) {
			await ComboService.admin.update({
				product_id: this.props.item?.id,
				...this.state.form,
				hasFile: true,
				photos: this.state.photos.filter((i: any) => i.id == null).map((i: any) => i?.value),
				photos_deleted: JSON.stringify(this.state.photos_deleted),
				products_ids: JSON.stringify(this.state.products.map((i: any) => i.id))
			});
			Globals.showSuccess("Se ha modificado el combo correctamente");
			this.props.onClose();
		}
		else {
			await ComboService.admin.create({
				...this.state.form,
				hasFile: true,
				photos: this.state.photos.map((i: any) => i?.value),
				products_ids: JSON.stringify(this.state.products.map((i: any) => i.id))
			});
			Globals.showSuccess("Se ha creado el combo correctamente");
			this.props.onClose();
		}
	}
	
	render() {
		const { visible } = this.state;

		return (
			<div id="modal-create-combo">
				{
					visible && (
						<ModalSelectProducts
							title="Productos"
							products={ this.state.products }
							onClose={ (products: any = null) => {
								this.setState({
									visible: false
								},() => {
									if (products != null) {
										this.setState({
											products
										});
									}
								});
							} }
						/>
					)
				}

				{
					!visible && (
						<React.Fragment>
							<TitleModalRight
								title={ this.props.title }
								onClose={ this.props.onClose }
							/>
							<form className="row" onSubmit={ this.submit }>
								<div className="col-md-12">
									<div className="container-photos" style={ this.state.photos.length > 0 ? { flexWrap: 'wrap' } : {} }>
										{
											this.state.photos.map((item: any,index) => {
												return (
													<div style={ this.state.photos.length > 0 ? { flex: .2 } : {} }>
														<PaperClip
															value={ null }
															successText={ `` }
															pendingText={ `` }
															width={ 1080 }
															height={ 1080 }
															onChange={ (e: any) => {
																let photos: any = [...this.state.photos];
																let photos_deleted: any = [...this.state.photos_deleted];
																if (item?.id != null) {
																	photos_deleted.push(item?.id);
																}
																photos[index] = e.target;
																this.setState({
																	photos,
																	photos_deleted
																});
															} }>
															<div className="item-photo" style={{ backgroundImage: `url(${ item?.id != null ? (Constants.BASE_STORAGE + item?.file) : item.dataURL })` }}>
																{
																	!item.dataURL && !item.id && (
																		<img src={ item.dataURL || WhiteImage } />
																	)
																}
																<button type="button" className="btn-delete" onClick={ async (e: any) => {
																	e.stopPropagation();
																	let photos: any = [...this.state.photos];
																	let photos_deleted: any = [...this.state.photos_deleted];
																	if (item?.id != null) {
																		photos_deleted.push(item?.id);
																	}
																	photos.splice(index,1);
																	await this.setState({
																		photos,
																		photos_deleted
																	});
																} }>
																	<img src={ CloseWhiteIcon } />
																</button>
															</div>
														</PaperClip>
													</div>
												)
											})
										}
										{
											this.state.photos.length < 5 && (
												<div style={ this.state.photos.length > 0 ? { flex: .2 } : {} }>
													<PaperClip
														value={ null }
														successText={ `` }
														pendingText={ `` }
														width={ 1080 }
														height={ 1080 }
														onChange={ (e: any) => {
															let photos: any = [...this.state.photos];
															photos.push(e.target);
															this.setState({
																photos
															});
														} }>
														<div className="item-photo">
															<img src={ WhiteImage } />
														</div>
													</PaperClip>
												</div>
											)
										}
										{
											this.state.photos.length == 0 && (
												<p className="message-images">Suba las imagenes del combo (Max. 5 imagenes). Tamaño requerido: 1080px por 1080px</p>
											)
										}
									</div>
								</div>
								<div className="col-md-12">
									<div className="container-padding">
										<Input
											color="white"
											value={ this.state.form.name }
											name="name" 
											placeholder="Nombre"
											onChange={ this.change } />
									</div>
								</div>
								<div className="col-md-12">
									<div className="container-padding">
										<Textarea
											rows={ 3 }
											placeholder="Descripción"
											name="description"
											onChange={ this.change }
						                    value={ this.state.form.description } />
						            </div>
								</div>
								<div className="col-md-12">
									<div className="item-products" onClick={ () => {
										this.setState({
											visible: true
										});
									} }>
										<p>Productos a incluir</p>
						            </div>
								</div>
								<div className="col-12">
									{
										this.state.products.map((item: any, index: number) => {
											return (
												<div className="item-product">
													<button className="btn-close" type="button" onClick={ () => {
														let products: any = [...this.state.products];
														products.splice(index,1);
														this.setState({
															products
														});
													} }>
														<img src={ CloseIcon } />
													</button>
													<p>{ item?.name }</p>
												</div>
											)
										})
									}
								</div>
								<div className="col-12">
									<hr />
								</div>
								<div className="col-md-12">
									<Input
										className="input-price"
										type="decimal"
										color="white"
										name="price"
										label="Precio de Venta"
										value={ this.state.form.price }
										onChange={ (e: any) => this.change(e) } />
								</div>
								<div className="row row-buttons">
									<div className="col-md-6">
										<div className="text-center">
											<Button type="button" className="btn-cancel" onClick={ () => this.props.onClose() }>
												Cancelar
											</Button>
										</div>
									</div>
									<div className="col-md-6">
										<div className="text-center">
											<Button type="submit">
												Guardar
											</Button>
										</div>
									</div>
								</div>
							</form>
						</React.Fragment>
					)
				}
			</div>
		)
	}
}

export default ModalCreateCombo;